module.exports = __webpack_public_path__ + "static/img/blue_01_471.207da31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/blue_01_471.png
// module id = 8N0I
// module chunks = 0